 /**
 * 操作权限处理 
 */

import Vue from 'vue'
const hasPermi = {
  state: {
    hasPermiInfo: null
  },
  actions: {
    setHasPermiData: function (context, hasPermiInfo) {
      context.state.hasPermiInfo = hasPermiInfo
      // 注册全局授权操作信息
      let hasPermiInfoCodes = hasPermiInfo
      Vue.prototype.authorize = {
        // 用户管理
        user: {
          add: hasPermiInfoCodes.includes('USER_ADD'),
          edit: hasPermiInfoCodes.includes('USER_EDIT'),
          enableFalse: hasPermiInfoCodes.includes('USER_ENABLE_FALSE'),
          enableTrue: hasPermiInfoCodes.includes('USER_ENABLE_TRUE'),
          changePwd: hasPermiInfoCodes.includes('USER_CHANGE_PWD')
        },
        // 租户管理
        tenant: {
          add: hasPermiInfoCodes.includes('TENANT_ADD'),
          edit: hasPermiInfoCodes.includes('TENANT_EDIT'),
          enableFalse: hasPermiInfoCodes.includes('TENANT_ENABLE_FALSE'),
          enableTrue: hasPermiInfoCodes.includes('TENANT_ENABLE_TRUE')
        },
        // 密码模块管理
        syskey: {
          add: hasPermiInfoCodes.includes('PWD_ADD'),
          // edit: hasPermiInfoCodes.includes('PWD_EDIT'),
          delete: hasPermiInfoCodes.includes('PWD_DELETE'),
          enableFalse: hasPermiInfoCodes.includes('PWD_ENABLE_FALSE'),
          enableTrue: hasPermiInfoCodes.includes('PWD_ENABLE_TRUE'),
          // detail : hasPermiInfoCodes.includes('PWD_DETAIL')
        }, 
        // 服务器网络配置
        network: {
          edit: hasPermiInfoCodes.includes('SYS_NETWORK_EDIT'),
          switch: hasPermiInfoCodes.includes('SYS_NETWORK_SWITCH'),
          refresh: hasPermiInfoCodes.includes('SYS_NETWORK_REFRESH')
        },
        // 系统操作日志
        log: {
          export: hasPermiInfoCodes.includes('SYS_LOG_EXPORT'),
          checks: hasPermiInfoCodes.includes('SYS_LOG_CHECKALL'),
          check: hasPermiInfoCodes.includes('SYS_LOG_CHECK'),
          detail: hasPermiInfoCodes.includes('SYS_LOG_DETAIL'),
        }
      }
    }
  }
}

export default hasPermi
